import { useAtomValue } from 'jotai'
import { addMilliseconds, differenceInMilliseconds } from 'date-fns'
import { formatDurationHuman } from '../../../utils'
import { timestampsAtom } from '../../../store/timestamps.store.js'

/**
 * OverUnder Component
 *
 * Displays the "over/under" status for a rundown, comparing the calculated end
 * with the planned rundown end. Shows whether the rundown is early, on time,
 * or late.
 *
 * Both values come from the timestamps store, which resolves them onto the
 * show's day in the rundown timezone.
 */
export default function OverUnder() {
  const timestamps = useAtomValue(timestampsAtom)

  if (!timestamps?.plannedEnd) return null

  const actualEnd = addMilliseconds(
    timestamps.actual.start,
    timestamps.actual.duration,
  )
  const diff = differenceInMilliseconds(timestamps.plannedEnd, actualEnd)

  return (
    <section>
      <div
        className={[
          'pl-1.5 text-gray-500 font-semibold whitespace-pre text-[10px]',
        ].join(' ')}
      >
        <p>Over / Under</p>
      </div>
      <p className="h-6 px-1.5 flex items-center font-mono tabular-nums">
        {diff >= 1000 ? (
          <span className="text-green-500">
            {formatDurationHuman(diff)} early
          </span>
        ) : (
          ''
        )}
        {Math.abs(diff) < 1000 ? 'On time' : ''}
        {diff <= -1000 ? (
          <span className="text-red-500">
            {formatDurationHuman(diff, { prefix: '' })} late
          </span>
        ) : (
          ''
        )}
      </p>
    </section>
  )
}
